import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ChipInput from 'material-ui-chip-input'
import CustomSelect from "../Select";
import {Grid, Typography} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {removeItemFromArray, superSplit} from "../../utils/functions";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";
import {LOCKED_SITES} from "../../config/constants";
import Tooltip from "@material-ui/core/Tooltip";
const value = [];
const state = {
    chat: true,
    mail: true,
};

const Theme = (borderRadius = '0 0 0 0') => createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: borderRadius,
            },
            input: {
                padding: '10px 14px',
            }
        },
        MuiInputLabel: {
            formControl: {
                top: '-12px',
                left: '10px'
            }
        },
        MuiDialogActions: {
            root: {
                justifyContent: 'center'
            }
        },
        MuiButton: {
            root: {
                borderRadius: borderRadius,
            },
            containedPrimary: {
                color: '#fff'
            },
            contained: {
                color: '#7a865d'
            }
        }
    },
    palette: {
        primary: {
            main: '#95c61c'
        },

        secondary: {
            main: '#95c61c',
            light: '#b2d164'
        },
    },
});

class AddNew extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            value,
            state,
            site: this.props.sites[0] || 'Svadba'
        }



        this.handleChange = (event) => {
            this.setState({ ...this.state, state: {...this.state.state, [event.target.name]: event.target.checked }});
        };

        this.handleClose = () => {
            this.setState({state, value})
            this.props.onClose();
        };

        this.handleSuccess = () => {
           this.props.onSuccessAdded(this.state.value, this.state.site, Object.keys(this.state.state).filter(i => (this.state.state[i] && LOCKED_SITES[this.state.site] != i)));
           this.setState({state, value, site: this.props.sites[0] || 'Svadba'})
           this.props.onClose();
        }
    }

   render() {
       return (
           <div>
               <Dialog fullWidth open={this.props.open} onClose={this.handleClose} aria-labelledby="form-dialog-title"
                       style={{textAlign: "center"}}>
                   <DialogTitle id="form-dialog-title"><b>Новый аккаунт</b></DialogTitle>
                   <ThemeProvider  theme={Theme('34px' || '0 0 0 0')}>
                   <DialogContent style={{textAlign: "center"}}>
                       <Grid container style={{display: "flex", alignItems: 'center'}}>
                           <Grid item xs={7} sm={7} md={7} lg={7} style={{textAlign: "center"}}>
                               <Typography>
                                   Выберите сайт
                               </Typography>
                               <CustomSelect
                                   onChange={(e) => {
                                       this.setState({site: e})
                                   }}
                                   name={'site'}
                                   value={this.state.site}
                                   rowsPerPageOptions={this.props.sites}
                                   borderRadius={'20px 20px 20px 20px'}
                                   width={'100%'}
                                   styles={{marginBottom: '10px', textAlign: "left"}}
                               />
                           </Grid>
                           <Grid item xs={5} sm={5} md={5} lg={5}>
                               {(!LOCKED_SITES[this.state.site] || LOCKED_SITES[this.state.site] !== 'chat') && <FormControlLabel
                                   control={
                                       <Checkbox
                                           checked={this.state.state.chat}
                                           onChange={this.handleChange}
                                           name="chat"
                                           color={'primary'}/>}
                                   label="Chat"
                               />}
                               {(!LOCKED_SITES[this.state.site] || LOCKED_SITES[this.state.site] !== 'mail') && <FormControlLabel
                                   control={
                                       <Checkbox
                                           checked={this.state.state.mail}
                                           onChange={this.handleChange}
                                           name="mail"
                                           color="primary"
                                       />
                                   }
                                   label="Mail"
                               />}
                           </Grid>
                       </Grid>
                       <Typography>
                           Поле ввода ID
                       </Typography>
                       <Tooltip title={'Введите ID и нажмите пробел.'}>
                       <ChipInput
                           variant={'outlined'}
                           onChange={(e) => this.setState({e})}
                           fullWidth={true}
                           blurBehavior={'add'}
                           clearInputValueOnChange
                           placeholder={'Введите ID и нажмите пробел.'}
                           onUpdateInput={(e) => {
                               let text = e.target.value;

                               if (/[ ,\n;+]+$/.test(text)) {
                                   let value = this.state.value.concat(superSplit(text))
                                   this.setState({value});
                               }
                           }}
                           value={this.state.value}
                           onDelete={(e) => {
                               let value = removeItemFromArray(this.state.value, e);
                               this.setState({value})
                           }}
                       />
                       </Tooltip>
                   </DialogContent>
                   <DialogActions>
                       <Button variant={'contained'} onClick={this.handleClose} color="default">
                           Отмена
                       </Button>
                       <Button disabled={!this.state.value.length}  variant={'contained'} onClick={this.handleSuccess} color="primary">
                           Добавить
                       </Button>
                   </DialogActions>
                   </ThemeProvider>
               </Dialog>
           </div>
       );
   }
}

export default AddNew